import { render, staticRenderFns } from "./remove-button.vue?vue&type=template&id=c8a7aa60&"
import script from "./remove-button.vue?vue&type=script&lang=ts&"
export * from "./remove-button.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8a7aa60')) {
      api.createRecord('c8a7aa60', component.options)
    } else {
      api.reload('c8a7aa60', component.options)
    }
    module.hot.accept("./remove-button.vue?vue&type=template&id=c8a7aa60&", function () {
      api.rerender('c8a7aa60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/components/matrix-actions/remove-button/remove-button.vue"
export default component.exports